import React from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import Events from "../../components/events/events";
import "./auftritte.scss"

const Auftritte = () => {

    return (
        <motion.div
            className="auftritte"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <Helmet>
                <title>Auftritte und Termine | Musikkapelle St. Lorenzen</title>
            </Helmet>
            
            <Events />
        </motion.div>
    )
};

export default Auftritte